import { Option } from './table-models';

/**
 * Configurable variables for the backend.
 * Should be able to be changed only by the Admin.
 */
export interface Configuration {
    name: string;
    value: string;
}

export interface AllConfigurations {
    aromaInfo: Configuration[];
    timerDays: Configuration[];
    workTimes: Configuration[];
    bankInfo: Configuration[];
    emailInfo: Configuration[];
    colors: Configuration[];
    invoiceDetails: Configuration[];
    prefixes: Prefix[];
    misc: Configuration[];
}

export interface Configurations {
    aromaInfo: AromaInfo;
    timerDays: TimerDays;
    workTimes: WorkTimes;
    bankInfo: BankInfo;
    emailInfo: EmailInfo;
    colors: ConfigurationColors;
    invoiceDetails: InvoiceDetails;
    prefixes: Prefix[];
    misc: MiscConfiguration;
}

export interface AromaInfo {
    email: string;
    phone: string;
    address: string;
    companyName?: string;
    owner?: string;
    vat?: string;
}

export interface InvoiceDetails {
    invoiceNumber: string;
    currency: string;
    dds: string;
}

export interface WorkTimes {
    fromWorkTime: string;
    toWorkTime: string;
}

export interface TimerDays {
    maintenanceDays: number;
    urgentServiceDays: number;
    needServiceDays: number;
    invoiceDays: number;
}

export interface BankInfo {
    aromaCompanyName: string;
    bankName: string;
    iban: string;
    swift: string;
}

export interface EmailInfo {
    email: string;
    emailPassword: string;
    emailSubject: string;
    emailBody: string;
    emailCopy: string;
}

export interface ConfigurationColors {
    clientWithTroubleTicketColor: string;
    inactiveClientColor: string;
    newClientColor: string;
    noServiceNeededColor: string;
    needServiceColor: string;
    urgentServiceColor: string;
    passServiceColor: string;
}

export interface Prefix {
    mainGroup: string;
    prefix: string;
}

export interface MiscConfiguration {
    maxLoginAttempts: string;
    salesRate: string;
}

export const colorOptions: readonly Option[] = [
    { name: 'lightBlue', value: '#6FBCFF' },
    { name: 'blue', value: '#005BE5' },
    { name: 'green', value: '#1CC328' },
    { name: 'purple', value: '#A954EC' },
    { name: 'gray', value: '#858585' },
    { name: 'red', value: '#FF4646' },
    { name: 'yellow', value: '#FFA500' },
    { name: 'pink', value: '#FF62D3' },
    { name: 'black', value: '#000000' },
];

export interface VatPrefix {
    mainGroup: string;
    prefix: string;
}

export interface EssencePriceGroup {
    id?: number;
    groupNumber: number;
    color: string;
    bonusRate: number;
}

export interface DeviceGroup {
    id?: number;
    groupNumber: number;
    color: string;
    bonusRate: number;
}

export interface ReedInstallationGroup extends DeviceGroup {}

export interface ConsumableServiceGroup extends DeviceGroup {}
